import ArrowRightIcon from '@/common/assets/icons/arrowRightIcon.svg?react';
import { DamagedPartDescriptionModalProps } from '@/common/components/adjusterReport/damagedPoints/damagedPointsDescriptionModal/DamagedPointsDescriptionModal.type';
import Button from '@/common/components/base/button/Button';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import useModal from '@/common/hooks/useModal';
import { requiredText } from '@/common/utils/rules/publicRules';
import { useDamagedPartDescriptionQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/damagedPartDescription/damagedPartDescriptionQueryOptions';
import { getDamagedPartDescriptionQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/damagedPartDescription/getDamagedPartDescriptionQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const DamagedPointsDescriptionModal = ({
  userType,
}: DamagedPartDescriptionModalProps) => {
  const { openModal, closeModal, open } = useModal();
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        gap={3}
        cursor="pointer"
        onClick={openModal}
      >
        <Typography color="purple-2" textStyle="b4">
          توضیحات تکمیلی
        </Typography>
        <ArrowRightIcon
          width={8}
          height={8}
          stroke={token('colors.purple-2')}
        />
      </Box>
      <MainModal open={open} closeModal={closeModal}>
        <Modal userType={userType} closeModal={closeModal} />
      </MainModal>
    </>
  );
};
export default DamagedPointsDescriptionModal;
const Modal = ({
  userType,
  closeModal,
}: DamagedPartDescriptionModalProps & Pick<MainModalProps, 'closeModal'>) => {
  const methods = useForm();

  const { id, damagedId } = useParams();

  const { mutateAsync } = useDamagedPartDescriptionQueryOptions();
  useQuery(
    getDamagedPartDescriptionQueryOptions({
      damaged_id: +damagedId!,
      id: +id!,
      userType: userType,
      success(data) {
        methods.setValue('description', data.damaged_parts_description);
      },
    }),
  );

  const submitForm = (data: Record<string, string>) => {
    mutateAsync({
      data: {
        damaged_parts_description: data.description,
      },
      id: +id!,
      damaged_id: +damagedId!,
      userType: userType,
    }).then(() => {
      closeModal();
    });
  };
  return (
    <>
      <TitleDescription>توضیحات تکمیلی</TitleDescription>
      <Typography textStyle="b2" mt={24} color="black-1">
        درصورتی که قطعه آسیب‌دیده وسیله‌نقلیه در لیست نبوده و همچنین جهت ارائه
        توضیحات تکمیلی در مورد نقاط آسیب‌دیده وسیله‌نقلیه می‌توانید توضیحات لازم
        را ارائه نمایید.
      </Typography>
      <Box mt={40}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(submitForm)}>
            <TextInput
              name="description"
              label="توضیحات تکمیلی"
              placeholder="توضیحات تکمیلی را وارد کنید"
              rules={{
                required: requiredText,
              }}
            />
            <Button
              fullWidth
              mt={20}
              type="submit"
              disabled={!methods.formState.isValid}
            >
              ثبت
            </Button>
          </form>
        </FormProvider>
      </Box>
    </>
  );
};
